import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { AdobeLaunchService } from '../shared/services/adobe-launch.service';
import { ActivatedRoute } from '@angular/router';
import { LinkComponent } from '@vg-constellation/angular-16/link';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements AfterViewInit, OnDestroy {

    @ViewChild('theIdea')
    theIdeaSection!: ElementRef;

    @ViewChild('theIdeaSidenavEnglish')
    theIdeaSidenavEnglish!: LinkComponent;

    @ViewChild('theIdeaSidenavSpanish')
    theIdeaSidenavSpanish!: LinkComponent;

    @ViewChild('vanguard')
    vanguardSection!: ElementRef;

    @ViewChild('acknowledgements')
    acknowledgementsSection!: ElementRef;

    @ViewChild('contact')
    contactSection!: ElementRef;

    @ViewChild('contactSidenavEnglish')
    contactSidenavEnglish!: LinkComponent;

    @ViewChild('contactSidenavSpanish')
    contactSidenavSpanish!: LinkComponent;

    contactUsQueryParamSubscription: any;

    constructor(
        private readonly adobeLaunchService: AdobeLaunchService,
        private route: ActivatedRoute,
        private readonly translateService: TranslateService
    ) {
    }

  ngOnInit(): void {
    this.adobeLaunchService.trackPageView({
      pageTitle:'About Us'
    });
  }

  ngAfterViewInit(): void {
    this.contactUsQueryParamSubscription = this.route.queryParams?.subscribe((params) => {
      const isContactUsLink = params["contact"];
      if (isContactUsLink) {
        this.onContactUsClick(this.translateService.currentLang);
      }
    });
  }

  onSidebarNavClick(elementName: string): void {
    const sectionMap: { [key: string]: ElementRef } = {
      theIdea: this.theIdeaSection,
      vanguard: this.vanguardSection,
      acknowledgements: this.acknowledgementsSection,
      contact: this.contactSection,
    };
  
    const targetSection = sectionMap[elementName];
    if (targetSection) {
      setTimeout(() => {
        targetSection.nativeElement.focus({ preventScroll: true });
      }, 0);
    }
  }

  onContactUsClick(lang: string): void {
    this.contactSection.nativeElement.classList.remove('hidden');
    this.theIdeaSection.nativeElement.classList.add('hidden');

    if (lang === 'en') {
      this.contactSidenavEnglish.elRef.nativeElement.classList.add('active');
      this.contactSidenavSpanish.elRef.nativeElement.classList.remove('active');
    } else if (lang === 'es') {
      this.contactSidenavEnglish.elRef.nativeElement.classList.remove('active');
      this.contactSidenavSpanish.elRef.nativeElement.classList.add('active');
    }

    this.theIdeaSidenavEnglish.elRef.nativeElement.classList.remove('active');
    this.theIdeaSidenavSpanish.elRef.nativeElement.classList.remove('active');
  }

  ngOnDestroy(): void {
    if (this.contactUsQueryParamSubscription) {
      this.contactUsQueryParamSubscription.unsubscribe();
    }
  }
}
